import React, { useEffect, useState } from 'react'
import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components'
import Axios from 'axios'

const Container = styled.div`
  display: flex;
  /* justify-content: space-between; */
  justify-content: center;
  padding: .8em 2.2em .8em 2.2em;
  flex-direction: column;
  background: ${({ checked }) => checked ? '#F7F2F7' : '#ffffff'};
  @media screen and (max-width: 500px) {
    width: max-content
  }
`
const ProductImg = styled.img`
  width: 55px;
  height: 55px;
  border-radius: 12px;
  margin-right: 1em;
`
const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({margin})=> margin};
  width: ${({width})=> width};
  height: ${({height})=> height};
  @media screen and (max-width: 500px) {
    margin: ${({marginMobile}) => marginMobile};
  }
`
const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${({margin})=> margin};
  width: ${({width})=> width};
  height: ${({height})=> height};
  @media screen and (max-width: 500px) {
    margin: ${({marginMobile}) => marginMobile};
  }
`
const SKUTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  margin-bottom: .2em;
  margin: ${({margin})=> margin};
`
const DetailTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: ${({fontWeight='normal'}) => fontWeight};
  font-size: 14px;
  line-height: 18px;
  color: ${({color='#6A6A6A'})=> color};
  margin: ${({margin})=> margin};
  text-overflow: ellipsis;
`
const PurpleCheckbox = withStyles({
  root: {
    color: '#CFD4D8',
    '&$checked': {
      color: '#5E388A',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

const ItemSKU = ({ cud, sku, quantity, brand, description, price, pickerDni, clientDni, obs, checked, onClickCheckBox, showCheckbox }) => {

  const [img, setImg] = useState(null)

  useEffect(() => {
    fetchImg()
    // eslint-disable-next-line
  }, [])

  const fetchImg = async () => {
    try {
      const { data } = await Axios.get(`https://simple.ripley.com.pe/api/v2/products/${sku}`);
      console.log(data);
      setImg(data.thumbnailImage);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <Container checked={checked}>
      <RowDiv>
        <RowDiv margin={showCheckbox ? '0 1em 0 0' : '0 2em 0 0'} marginMobile='0 1.5em 0 0'>
          { showCheckbox && <PurpleCheckbox checked={checked} onClick={() => onClickCheckBox(cud)} />}
          <ProductImg src={img ? img : require('../../../../assets/images/no-image-found.png')} />
          <ColumnDiv>
            <SKUTxt>SKU <span style={{fontWeight:500}}>{sku}</span> <span style={{marginLeft:'.5em',color:'#F15B5B'}}>x {quantity}</span></SKUTxt>
            <DetailTxt>CUD <spna style={{fontWeight:500}}>{cud}</spna></DetailTxt>
          </ColumnDiv>
        </RowDiv>
        <ColumnDiv margin='0 3em 0 0' marginMobile='0 1.5em 0 0'>
          <DetailTxt color='#333333' margin='0 0 .3em 0'>Pickeado por <DetailTxt color='#333333' fontWeight={500}>{pickerDni}</DetailTxt></DetailTxt>
          <DetailTxt color='#6A6A6A'>DNI <DetailTxt color='#6A6A6A' fontWeight={500}>{clientDni}</DetailTxt></DetailTxt>
        </ColumnDiv>
        <ColumnDiv marginMobile='0 1.5em 0 0'>
          <DetailTxt color='#7C3F88' margin='0 0 .3em 0' fontWeight={500}>{brand}</DetailTxt>
          {/* <SKUTxt margin='0 0 0 auto'>S/ <span style={{fontWeight:500}}>{price.toFixed(2)}</span></SKUTxt> */}
          <DetailTxt >{description}</DetailTxt>
        </ColumnDiv>
        <ColumnDiv margin='0 0 0 auto' marginMobile='0 1.5em 0 0'>
          <SKUTxt margin='0 0 0 auto'>S/ <span style={{fontWeight:500}}>{price.toFixed(2)}</span></SKUTxt>
          <RowDiv width='1em' height='1em'></RowDiv>
        </ColumnDiv>
      </RowDiv>
      {obs &&
        <RowDiv margin='0 0 0 4.5em'>
          <DetailTxt color='#EE2737'>Rechazado por <DetailTxt color='#EE2737' fontWeight={500}>{obs}</DetailTxt></DetailTxt>
        </RowDiv>
      }
    </Container>
  )
}

ItemSKU.propTypes = {

}

export default ItemSKU
